import { useState } from 'react'
import { 
  Zap, 
  Sword,
  Clock,
  Eye,
  PlayCircle
} from 'lucide-react'
import { Button } from '../components/ui/button'

interface Battle {
  id: string
  attacker: string
  defender: string
  location: string
  status: 'active' | 'victory' | 'defeat' | 'pending'
  duration: string
  attackerForces: number
  defenderForces: number
}

const Combat = () => {
  const [battles] = useState<Battle[]>([
    {
      id: '1',
      attacker: 'You',
      defender: 'Crimson Raiders',
      location: 'Kepler-442b',
      status: 'active',
      duration: '15m',
      attackerForces: 12,
      defenderForces: 8
    },
    {
      id: '2',
      attacker: 'Voidborn Collective',
      defender: 'You',
      location: 'Sol System',
      status: 'pending',
      duration: 'Incoming in 2h',
      attackerForces: 20,
      defenderForces: 15
    }
  ])

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-purple-900 to-slate-900 pt-16">
      <div className="container mx-auto px-4 py-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-4xl font-bold text-white mb-2 flex items-center">
              <Zap className="w-10 h-10 mr-3 text-red-400" />
              Combat Operations
            </h1>
            <p className="text-gray-400">Manage battles and military campaigns</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {battles.map((battle) => (
            <div key={battle.id} className="bg-slate-800/50 backdrop-blur-sm rounded-lg border border-white/10 p-6">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center space-x-2">
                  <Sword className="w-6 h-6 text-red-400" />
                  <span className={`px-2 py-1 rounded text-xs ${
                    battle.status === 'active' ? 'bg-red-600/20 text-red-400' :
                    battle.status === 'pending' ? 'bg-yellow-600/20 text-yellow-400' :
                    'bg-gray-600/20 text-gray-400'
                  }`}>
                    {battle.status}
                  </span>
                </div>
                <Clock className="w-4 h-4 text-gray-400" />
              </div>
              
              <h3 className="text-lg font-bold text-white mb-2">{battle.location}</h3>
              <div className="text-sm text-gray-400 mb-4">
                <div>{battle.attacker} vs {battle.defender}</div>
                <div>Duration: {battle.duration}</div>
              </div>
              
              <div className="flex justify-between mb-4">
                <div className="text-center">
                  <div className="text-xs text-gray-400">Attacker</div>
                  <div className="text-lg font-bold text-blue-400">{battle.attackerForces}</div>
                </div>
                <div className="text-center">
                  <div className="text-xs text-gray-400">Defender</div>
                  <div className="text-lg font-bold text-purple-400">{battle.defenderForces}</div>
                </div>
              </div>
              
              <div className="flex gap-2">
                <Button variant="outline" size="sm" className="flex-1">
                  <Eye className="w-4 h-4 mr-2" />
                  View
                </Button>
                {battle.status === 'pending' && (
                  <Button size="sm" className="flex-1">
                    <PlayCircle className="w-4 h-4 mr-2" />
                    Deploy
                  </Button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Combat